import React from "react";
import { Box, InternalStandardProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppContentListItem } from "JS/React/Components/AppContentListItem";

const EditIcons = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    paddingTop: "20px",
    paddingBottom: "20px",
    color: theme.palette.common.black,
}));

const ListWrapper = styled(Box)({
    width: "100% !important",
});

const DragHandleBox = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    paddingTop: "20px",
    paddingBottom: "20px",
    color: theme.palette.common.black,
    cursor: "grab",
    "&:active": {
        cursor: "grabbing",
    },
}));

export interface PlaylistElementProps
    extends InternalStandardProps<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >
    > {
    value: any;
    isEdit: boolean;
    handleAudioRemoval: () => void;
    isDownloadInProgress: boolean;
    isInDownloadQueue: boolean;
    isDownloaded: Promise<boolean>;
    inProgressDownloaded: boolean;
    isResume: boolean;
    isFavouriteContent: boolean;
    imageUrl: string;
    handleListItemClick: () => void;
    itemRef: any;
    dragHandleProps?: Record<string, any>;
}

export const PlaylistElement = (props: PlaylistElementProps) => {
    const {
        value,
        isEdit,
        handleAudioRemoval,
        isDownloadInProgress,
        isInDownloadQueue,
        isDownloaded,
        inProgressDownloaded,
        isResume,
        isFavouriteContent,
        imageUrl,
        handleListItemClick,
        itemRef,
        dragHandleProps,
    } = props;

    return (
        <Box
            display={"flex"}
            flexDirection={"row"}
            key={value.nid}
            ref={(el) => itemRef(el)}
        >
            {isEdit && (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    paddingLeft={"5px"}
                >
                    <EditIcons onClick={handleAudioRemoval}>
                        <FontAwesomeIcon icon={["fas", "square-minus"]} />
                    </EditIcons>
                    <DragHandleBox
                        {...dragHandleProps}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <FontAwesomeIcon icon={["fas", "bars"]} />
                    </DragHandleBox>
                </Box>
            )}
            <ListWrapper>
                <AppContentListItem
                    nid={value.nid}
                    key={value.nid}
                    isDownloadInProgress={isDownloadInProgress}
                    isInDownloadQueue={isInDownloadQueue}
                    isDownloaded={isDownloaded}
                    inProgressDownloaded={inProgressDownloaded}
                    type="media"
                    isReceived={value.isReceived}
                    isResume={isResume}
                    sender={value.sender}
                    title={value.title}
                    skuId={value.sku_id}
                    description={value.description}
                    releaseDate={value.release_date}
                    showPlayIcon={true}
                    showFavIcon={isFavouriteContent}
                    isFavourite={isFavouriteContent}
                    imageUrl={imageUrl}
                    isAllowClick
                    onListItemClick={handleListItemClick}
                    isFromPlaylist={true}
                />
            </ListWrapper>
        </Box>
    );
};
